import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import { ExplicitlyCompletableTask } from 'src/app/model/task-list/explicitly-completable-task';
import { TASK_TYPES } from 'src/app/model/task-list/task';
import { OfflineTaskChangesObject } from 'src/app/services/placer-offline-changes/task/offline-storage/offline-task-changes-object';
import { PlacerTaskChangesService } from 'src/app/services/placer-offline-changes/task/offline-storage/placer-task-changes.service';
import { LoadList } from '../load-task-placer-form/helper/load-task-placer-form-helper';

export default class OfflineTaskStorageHelper {
  private constructor() {}

  public static async getOfflineChanges(
    task: ExplicitlyCompletableTask,
    context: OfflineTaskStorageHelperContext
  ): Promise<OfflineTaskChangesObject> {
    const toReturn = await context.placerTaskChangesService.getObject(task.id);
    return toReturn != null ? toReturn : { id: task.id, type: task.type };
  }

  public static processOfflineRegisteredActions(
    task: ExplicitlyCompletableTask,
    taskChanges: OfflineTaskChangesObject
  ): void {
    if (task.id !== taskChanges.id) {
      throw new Error('task ids do not match');
    }

    if (!CollectionHelper.isPopulated(taskChanges.registeredActions)) {
      return;
    }

    if (task.registeredActions == null) {
      task.registeredActions = [];
    }
    task.registeredActions.push(...taskChanges.registeredActions);
    task.registeredActions.sort(GeneralHelper.compareRegisteredActionsDesc);
  }

  public static copyToTaskChanges(
    task: ExplicitlyCompletableTask,
    taskChanges: OfflineTaskChangesObject,
    loadList?: LoadList
  ): void {
    taskChanges.complete = task.complete;
    taskChanges.registeredActions = task.registeredActions;

    switch (task.type) {
      case TASK_TYPES.LOAD_TASK:
        if (loadList == null) {
          throw new Error(
            `loadList must not be null when storing ${TASK_TYPES.LOAD_TASK}`
          );
        }
        this.copyLoadTaskChanges(loadList, taskChanges);
        break;
      case TASK_TYPES.OTHER_TASK:
        break;
      default:
        throw new Error(`task type not recognized: ${task.type}`);
    }
  }

  private static copyLoadTaskChanges(
    loadList: LoadList,
    taskChanges: OfflineTaskChangesObject
  ): void {
    taskChanges.tilingLoadEntry = loadList.tilingLoadEntry;
    taskChanges.immoscoopAndOrSpottoAndOrInpressLoadEntry =
      loadList.immoscoopAndOrSpottoAndOrInpressLoadEntry;
    taskChanges.materialLoadEntries = loadList.materialLoadEntries;
  }
}

export interface OfflineTaskStorageHelperContext {
  placerTaskChangesService: PlacerTaskChangesService;
}
